<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="新增收货地址"
      :body-style="{ color: 'red' }"
      @ok="handleSubmit"
    >
      <a-form
        class="iotplt-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >

        <a-form-item label="收货人">
          <a-input
            v-decorator="['receiver', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入收货人' },
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="联系方式">
          <a-input
            v-decorator="['phone_number', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入联系方式' },
                { pattern: /^1[3-9]\d{9}$/, message: '联系方式格式不正确' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="邮编">
          <a-input
            v-decorator="['post_code', {
              normalize: this.$lodash.trim
            }]"
          />
        </a-form-item>

        <a-form-item :label="`所在地区`">
          <a-spin :spinning="loadingRegionOption">
            <a-cascader
              :field-names="{ label: 'name', value: 'id', children: 'children' }"
              :load-data="fetchRegionOptions"
              :show-search="{ filter: regionFilter, limit: false }"
              :options="regionOptions"
              placeholder="请选择所在地区"
              v-decorator="['region',{
                rules: [
                  { required: true, message: '请选择所在地区' },
                ]
              }]"
            />
          </a-spin>
        </a-form-item>

        <a-form-item label="详细地址">
          <a-input
            v-decorator="['address_detail', {
              normalize: this.$lodash.trim,
              rules:[
                { required: true, message: '请输入详细地址' },
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>

import { createReceiveAddress } from '@/api/receive_address'
import { findRegions } from '@/api/region'

export default {
  name: 'NewReceiveAddress',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'receive_address' }),
      submitting: false,
      regionOptions: [],
      loadingRegionOption: true
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchRegionOptions()
  },
  methods: {
    // 加载省市区选项
    fetchRegionOptions() {
      this.loadingRegionOption = true
      findRegions().then((res) => {
        if (res.code === 0) {
          this.regionOptions = res.data
        }
        this.loadingRegionOption = false
      })
    },

    regionFilter(inputValue, path) {
      return path.some(option => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          this.$set(values, 'agent_id', this.$store.getters.userAgentId)
          createReceiveAddress(values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
